import React, { useState, ReactNode } from "react";
import AddBulkCartContext, {
  AddBulkCartContextType,
  OutletType,
} from "./addBulkCartContext";

// Define props for the provider
interface AddBulkCartProviderProps {
  children: ReactNode;
}

// Create the provider component
export const AddBulkCartProvider: React.FC<AddBulkCartProviderProps> = ({
  children,
}) => {
  const [userId, setUserId] = useState<string>("");
  const [accessToken, setAccessToken] = useState<string>("");
  const [outlets, setOutlets] = useState<OutletType[]>([]);

  const resetContext = () => {
    setUserId("");
    setAccessToken("");
    setOutlets([]);
  };

  const contextValue: AddBulkCartContextType = {
    userId,
    accessToken,
    outlets,
    setUserId,
    setAccessToken,
    setOutlets,
    resetContext,
  };

  return (
    <AddBulkCartContext.Provider value={contextValue}>
      {children}
    </AddBulkCartContext.Provider>
  );
};

export default AddBulkCartProvider;
